export const TEXT_FIELDS = [
    {
        label: "Password",
        name: "password",
        variant: "outlined"
    },
    {
        label: "ConfirmPassword",
        name: "confirmPassword",
        variant: "outlined"
    }
]